module.exports = __webpack_public_path__ + "media/domenj/home-c445a8a1.png";